import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon, ExportIcon } from '@calendly/ui/components/icons';
import { Item, Menu } from '@calendly/ui/components/menu';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createDelayedExport as createInvitationsExport, InvitationsExportConfirmation, isLoadingSelector as invitationsIsLoadingSelector } from 'features/invitations_export';
import { createDelayedExport as createUsersExport, isLoadingSelector as usersIsLoadingSelector, UsersExportConfirmation } from 'features/users_export';
const containerIsTabletUpCss = "ckl62il";
const containerIsTabletDownCss = "c1d0tmwj";
const containerCss = "c1qygmz5";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  const isTabletDown = useDeviceType('isTabletDown');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsTabletUpCss]: isTabletUp,
    [containerIsTabletDownCss]: isTabletDown
  }, props.className)} />;
});
const exportMenuCss = "e1cq8rs1";
const ExportMenu = forwardRef((props, ref) => <Menu ref={ref} {...props} className={classNames(exportMenuCss, props.className)} />);
export const ExportDropdown = () => {
  const dispatch = useDispatch();
  const usersExportDisabled = useSelector(usersIsLoadingSelector);
  const invitationsExportDisabled = useSelector(invitationsIsLoadingSelector);
  const [toggleDropdown, Dropdown, isDropdownOpen] = useDropdown();
  const buttonProps = {
    decoration: 'ghost'
  };
  const onUsersExportClick = () => dispatch(createUsersExport());
  const onInvitationsExportClick = () => {
    dispatch(createInvitationsExport());
  };
  return <Container>
      <UsersExportConfirmation />
      <InvitationsExportConfirmation />
      <Button onClick={toggleDropdown} {...buttonProps}>
        <ExportIcon />
        {I18n.t('publisher.organization.members.export_members')}
        {isDropdownOpen ? <ArrowChevronUpMiniIcon /> : <ArrowChevronDownMiniIcon />}
      </Button>
      <Dropdown>
        <ExportMenu>
          <Item onClick={onUsersExportClick} disabled={usersExportDisabled}>
            {I18n.t('publisher.organization.members.member_status.active')}
          </Item>
          <Item onClick={onInvitationsExportClick} disabled={invitationsExportDisabled}>
            {I18n.t('publisher.organization.members.member_status.pending')}
          </Item>
        </ExportMenu>
      </Dropdown>
    </Container>;
};

require("./export_dropdown.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./export_dropdown.js");